import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import Seo from "../components/Seo";
import { MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
      toast.success("If an account exists, a reset email has been sent.");
    } catch {
      // backend always returns OK, but in case of network failure surface it
      toast.error("Could not send — please try again.");
    } finally { setBusy(false); }
  };

  return (
    <div className="mx-auto max-w-md px-6 lg:px-8 py-20" data-testid="forgot-password-page">
      <Seo title="Forgot password — BizzAtlas" description="Reset your BizzAtlas password." />
      <div className="text-xs font-mono-tag uppercase tracking-[0.2em] text-zinc-400 mb-2">/ Password</div>
      <h1 className="font-display text-4xl tracking-tight">Forgot password?</h1>
      <p className="text-sm text-zinc-600 mt-2 mb-8">Enter your email and we&apos;ll send you a reset link.</p>

      {done ? (
        <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-6 text-emerald-800" data-testid="forgot-done">
          <MailCheck className="h-6 w-6 mb-2" />
          <div className="font-display text-xl">Check your inbox.</div>
          <p className="text-sm mt-1">If that email is registered with BizzAtlas, a reset link is on its way. The link expires in 2 hours.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="fp-email">Email</Label>
            <Input id="fp-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
          </div>
          <Button type="submit" disabled={busy || !email} className="w-full btn-brand" data-testid="forgot-submit">{busy ? "Sending…" : "Send reset link"}</Button>
        </form>
      )}
      <div className="mt-6 text-sm text-zinc-500">
        Remember your password? <Link to="/login" className="underline text-zinc-900">Sign in</Link>
      </div>
    </div>
  );
}
